<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__2009.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">2009</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_2009_HEADLINE')">Eco First Enterprise</div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_2009_TEXT_01')">
                    1.We actively promote environmental measures in relation to our products, such as the use of the 3
                    Rs (Reduce, Reuse, Recycle) for containers and packaging.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_2009_TEXT_02')">
                    2.We will actively work on the conservation of the bounty of the Earth, which is the source of value
                    creation.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_2009_TEXT_03')">
                    3.We will engage in environmental education and develop our staff to contribute to the conservation
                    of the bounty of the Earth.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_2009_TEXT_04')">
                    4.We will actively promote initiatives to prevent global warming.
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-2009",
    }
</script>

<style scoped>

</style>